import { render, staticRenderFns } from "./orderStatistics.vue?vue&type=template&id=37dc9cda&"
import script from "./orderStatistics.vue?vue&type=script&lang=ts&"
export * from "./orderStatistics.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports